export default function redirectRoutes() {
    const routes = [
        // Manual product redirects needs to be before automatic product redirects
        { from: '^/customer/account/login/$', to: '/account/login' },
        { from: '^/customer/account/login$', to: '/account/login' },
    ];

    return routes;
}
